var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCommentQuestionCheck(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#59c778;}.cls-2{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_14",
    "data-name": "Layer 14"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2,
    y: 2,
    width: 12,
    height: 12,
    rx: 3
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M6.8,10.68,4.35,8.25a.42.42,0,0,1,0-.54l.54-.52a.36.36,0,0,1,.51,0v0L7.08,8.86l3.51-3.55a.35.35,0,0,1,.51,0h0l.54.53a.41.41,0,0,1,0,.53L7.32,10.68a.34.34,0,0,1-.5,0Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentQuestionCheck);
export default __webpack_public_path__ + "static/media/comment-question-check.416946aa02198a16f1d359d5aaf6c7f6.svg";
export { ForwardRef as ReactComponent };